export default __webpack_public_path__ + "static/media/SMK_TRAN.33640bce.png";